export default __webpack_public_path__ + "static/media/1128040325514717.99f05eac.jpg";